import { createSlice } from '@reduxjs/toolkit';

export type playlistState = {
  playlists: any;
};

const initialState: playlistState = { playlists: {} };

const playlistSlice = createSlice({
  name: 'playlists',
  initialState: initialState,
  reducers: {
    handlePlaylists(state, action) {
      const { playlistId, data } = action.payload;
      state.playlists[playlistId] = data;
    },
    updateVideoInPlaylists(state, action) {
      const { videoId, updatedVideo, updatedPlaylists, playlistId } = action.payload;
      // Iterate through each playlist
      updatedPlaylists.forEach((playlist: any) => {
        const playlists = state.playlists[playlist.hash_id];
        if (playlists) {
          const videoExists = playlists.videos?.some((video: any) => video.id === videoId);
          if (videoExists) {
            console.log('videoExists');
            playlists.videos = playlists.videos?.map((video: any) => {
              return video.id === videoId ? { ...video, playlists: updatedPlaylists } : video;
            });
          } else {
            playlists.videos.push({ ...updatedVideo, playlists: updatedPlaylists });
          }
        }
      });
    },
    updatePlaylistVideoField(state, action) {
      const { playlists, videoHashId, field, value } = action.payload;
      playlists.forEach((playlist: any) => {
        const playlistState = state.playlists[playlist.hash_id]; // Get the playlist from state
        if (playlistState) {
          const video = playlistState.videos?.find((video: any) => video.hash_id === videoHashId);
          if (video) {
            video[field] = value;
          }
        }
      });
    },
    removeVideoFromPlaylist(state, action) {
      const { playlists, videoHashId } = action.payload; // Expecting an array of removed playlists
      // Iterate through each playlist in the playlists
      playlists.forEach((removed: any) => {
        const { hash_id } = removed; // Get the hash_id from removed playlist
        const playlist = state.playlists[hash_id]; // Check if the playlist exists in the state
        if (playlist) {
          // Find the index of the video to be removed
          const videoIndex = playlist.videos.findIndex((video: any) => video.hash_id === videoHashId);
          // If the video exists, remove it
          if (videoIndex !== -1) {
            playlist.videos.splice(videoIndex, 1); // Remove the video at the found index
          }
        }
      });
    },
    removeVideoByChannel(state, action) {
      const { channelId, videoHashId } = action.payload;
      Object.values(state.playlists).forEach((playlist: any) => {
        if (playlist.channel_id === channelId) {
          playlist.videos = playlist.videos.filter((video: any) => video.hash_id !== videoHashId);
        }
      });
    }
  }
});

export const {
  handlePlaylists,
  updateVideoInPlaylists,
  removeVideoFromPlaylist,
  updatePlaylistVideoField,
  removeVideoByChannel
} = playlistSlice.actions;

export const playlistsReducer = playlistSlice.reducer;
